// extracted by mini-css-extract-plugin
module.exports = {"footer":"_99551c8aa8--footer--YIVyU","with-border":"_99551c8aa8--with-border--fhGFU"};